module.exports = __webpack_public_path__ + "static/alocasia-gageana-0-495689ab81181bbd9605c7c4d3e0cee1.png";